import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, LockIcon, ChevronRightIcon, CheckIcon } from 'lucide-react';
export const CheckoutPage = () => {
  // Mock cart summary - in a real app, this would be managed with state
  const cartSummary = {
    items: [{
      id: 1,
      name: 'MacBook Pro 2021',
      condition: 'Refurbished - Excellent',
      price: 1299,
      quantity: 1
    }, {
      id: 3,
      name: 'Gold Bar 1oz',
      condition: 'Investment Grade - 99.99% Pure',
      price: 2084,
      quantity: 1
    }],
    subtotal: 3383,
    shipping: 0,
    tax: 270.64,
    total: 3653.64
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-248">
      <div className="container mx-auto px-4 py-8" data-id="element-249">
        <h1 className="text-3xl font-bold mb-4" data-id="element-250">Checkout</h1>
        {/* Checkout Steps */}
        <div className="flex items-center mb-8" data-id="element-251">
          <div className="flex items-center" data-id="element-252">
            <div className="bg-green-500 rounded-full h-8 w-8 flex items-center justify-center" data-id="element-253">
              <CheckIcon size={16} className="text-white" data-id="element-254" />
            </div>
            <span className="ml-2 text-green-500 font-medium" data-id="element-255">Cart</span>
          </div>
          <ChevronRightIcon size={16} className="mx-3 text-gray-400" data-id="element-256" />
          <div className="flex items-center" data-id="element-257">
            <div className="bg-green-500 rounded-full h-8 w-8 flex items-center justify-center" data-id="element-258">
              <span className="text-white font-medium" data-id="element-259">2</span>
            </div>
            <span className="ml-2 text-green-500 font-medium" data-id="element-260">Checkout</span>
          </div>
          <ChevronRightIcon size={16} className="mx-3 text-gray-400" data-id="element-261" />
          <div className="flex items-center" data-id="element-262">
            <div className="bg-gray-200 rounded-full h-8 w-8 flex items-center justify-center" data-id="element-263">
              <span className="text-gray-500 font-medium" data-id="element-264">3</span>
            </div>
            <span className="ml-2 text-gray-500 font-medium" data-id="element-265">Confirmation</span>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-266">
          {/* Checkout Form */}
          <div className="lg:col-span-2" data-id="element-267">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6" data-id="element-268">
              <div className="p-6" data-id="element-269">
                <h2 className="text-lg font-bold mb-4" data-id="element-270">Contact Information</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-271">
                  <div data-id="element-272">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-273">
                      Email Address
                    </label>
                    <input type="email" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" placeholder="your@email.com" data-id="element-274" />
                  </div>
                  <div data-id="element-275">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-276">
                      Phone Number
                    </label>
                    <input type="tel" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" placeholder="(123) 456-7890" data-id="element-277" />
                  </div>
                </div>
                <h2 className="text-lg font-bold mb-4" data-id="element-278">Shipping Address</h2>
                <div className="grid grid-cols-1 gap-4 mb-6" data-id="element-279">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-280">
                    <div data-id="element-281">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-282">
                        First Name
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-283" />
                    </div>
                    <div data-id="element-284">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-285">
                        Last Name
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-286" />
                    </div>
                  </div>
                  <div data-id="element-287">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-288">
                      Address
                    </label>
                    <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" placeholder="Street address or P.O. Box" data-id="element-289" />
                  </div>
                  <div data-id="element-290">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-291">
                      Apartment, suite, etc.
                    </label>
                    <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-292" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-293">
                    <div data-id="element-294">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-295">
                        City
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-296" />
                    </div>
                    <div data-id="element-297">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-298">
                        State
                      </label>
                      <select className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-299">
                        <option value="" data-id="element-300">Select State</option>
                        <option value="CA" data-id="element-301">California</option>
                        <option value="NY" data-id="element-302">New York</option>
                        <option value="TX" data-id="element-303">Texas</option>
                        {/* More states would be listed here */}
                      </select>
                    </div>
                    <div data-id="element-304">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-305">
                        ZIP Code
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-306" />
                    </div>
                  </div>
                </div>
                <h2 className="text-lg font-bold mb-4" data-id="element-307">Payment Method</h2>
                <div className="border border-gray-200 rounded-lg p-4 mb-6" data-id="element-308">
                  <div className="flex items-center justify-between mb-4" data-id="element-309">
                    <div className="flex items-center" data-id="element-310">
                      <CreditCardIcon size={20} className="text-gray-600 mr-2" data-id="element-311" />
                      <span className="font-medium" data-id="element-312">Credit Card</span>
                    </div>
                    <div className="flex items-center" data-id="element-313">
                      <img src="https://cdn.worldvectorlogo.com/logos/visa-10.svg" alt="Visa" className="h-6 mr-2" data-id="element-314" />
                      <img src="https://cdn.worldvectorlogo.com/logos/mastercard-2.svg" alt="Mastercard" className="h-6 mr-2" data-id="element-315" />
                      <img src="https://cdn.worldvectorlogo.com/logos/american-express-logo-1.svg" alt="Amex" className="h-6" data-id="element-316" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-4" data-id="element-317">
                    <div data-id="element-318">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-319">
                        Card Number
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" placeholder="1234 5678 9012 3456" data-id="element-320" />
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-321">
                      <div data-id="element-322">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-323">
                          Expiration Date
                        </label>
                        <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" placeholder="MM/YY" data-id="element-324" />
                      </div>
                      <div data-id="element-325">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-326">
                          CVC
                        </label>
                        <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" placeholder="123" data-id="element-327" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center text-green-500 mb-6" data-id="element-328">
                  <LockIcon size={16} className="mr-2" data-id="element-329" />
                  <span className="text-sm" data-id="element-330">
                    Your payment information is secure and encrypted.
                  </span>
                </div>
                <button className="w-full bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 transition-colors" data-id="element-331">
                  Complete Order
                </button>
              </div>
            </div>
          </div>
          {/* Order Summary */}
          <div data-id="element-332">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden sticky top-24" data-id="element-333">
              <div className="p-6" data-id="element-334">
                <h2 className="text-lg font-bold mb-4" data-id="element-335">Order Summary</h2>
                {/* Order Items */}
                <div className="space-y-4 mb-6" data-id="element-336">
                  {cartSummary.items.map(item => <div key={item.id} className="flex justify-between" data-id="element-337">
                      <div data-id="element-338">
                        <span className="font-medium" data-id="element-339">{item.name}</span>
                        <span className="text-gray-500 text-sm block" data-id="element-340">
                          {item.condition}
                        </span>
                        <span className="text-gray-500 text-sm" data-id="element-341">
                          Qty: {item.quantity}
                        </span>
                      </div>
                      <span className="font-medium" data-id="element-342">
                        ${item.price.toFixed(2)}
                      </span>
                    </div>)}
                </div>
                <div className="border-t border-gray-200 pt-4 space-y-3 mb-6" data-id="element-343">
                  <div className="flex justify-between" data-id="element-344">
                    <span className="text-gray-600" data-id="element-345">Subtotal</span>
                    <span className="font-medium" data-id="element-346">
                      ${cartSummary.subtotal.toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-347">
                    <span className="text-gray-600" data-id="element-348">Shipping</span>
                    <span className="font-medium text-green-500" data-id="element-349">Free</span>
                  </div>
                  <div className="flex justify-between" data-id="element-350">
                    <span className="text-gray-600" data-id="element-351">Estimated Tax</span>
                    <span className="font-medium" data-id="element-352">
                      ${cartSummary.tax.toFixed(2)}
                    </span>
                  </div>
                  <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-353">
                    <span className="font-bold" data-id="element-354">Total</span>
                    <span className="font-bold" data-id="element-355">
                      ${cartSummary.total.toFixed(2)}
                    </span>
                  </div>
                </div>
                <Link to="/cart" className="text-green-500 hover:text-green-600 transition-colors text-sm inline-flex items-center" data-id="element-356">
                  <ChevronRightIcon size={16} className="mr-1 transform rotate-180" data-id="element-357" />
                  Return to Cart
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};